import axios from "axios";
import { IAgenda, IAppointment, IBox, IAgendasConfig, IResearcher, AgendasTypes } from "../constants/types";
import { IService, IServiceInvestigation } from "../pages/hospital/Request/types";



export function getAgendasConfig(uuidInvestigation: string): Promise<{ status: number, agendaConfig: IAgendasConfig }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/config", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updateAgendaConfigService(
    uuidInvestigation: string,
    params: IAgendasConfig['params']
): Promise<{ status: number, agendaConfig: IAgendasConfig }> {
    return new Promise((resolve, reject) => {
        axios
            .put(
                import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/config",
                params,
                { headers: { "Authorization": localStorage.getItem("jwt") } }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

// SHER-353: cohort of patients with at least one appointment today (agenda timezone).
// Returns only PatientInvestigation uuids + the earliest appointment time; the client
// hydrates the (encrypted) patient data from its local store.
export function getPatientsWithAppointmentTodayService(uuidInvestigation: string): Promise<{ status: number, patients: { uuid: string, startDateTime: number }[] }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/patients-today", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getReseachersFromDepartment(uuidInvestigation: string, uuidDepartment:string): Promise<{ status: number, researchers: IResearcher[] }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/box/all", { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data); 
            })
            .catch((error) => {
                reject(error);
            });
    });
} 

export function getServicesInvestigationService(uuidInvestigation: string, serviceType:number): Promise<{ status: number, servicesInvestigation: IServiceInvestigation[] }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/services/" + serviceType, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data); 
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getBoxesService(uuidInvestigation: string, typeAgenda:AgendasTypes): Promise<{ status: number, boxes: IBox[] }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/box/" + typeAgenda, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data); 
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getServiceGeneralService(serviceType:number): Promise<{ status: number, services: IService[] }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/hospital/servicesgeneral/" + serviceType, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data); 
            })
            .catch((error) => {
                reject(error);
            });
    })
}

export function saveServiceInvestigationService(uuidInvestigation: string, serviceInvestigation:IServiceInvestigation): Promise<{ status: number, serviceInvestigation: IServiceInvestigation }> {
    return new Promise((resolve, reject) => {
        axios.post(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/service/", serviceInvestigation, { headers: { "Authorization": localStorage.getItem("jwt") } }).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
            reject(response.data); 
        })
        .catch((error) => {
            reject(error);
        });
    });
}
    
export function updateServiceInvestigationService(uuidInvestigation: string, serviceInvestigation:IServiceInvestigation): Promise<{ status: number, serviceInvestigation: IServiceInvestigation }> {
    return new Promise((resolve, reject) => {
        axios.put(import.meta.env.VITE_APP_API_URL + "/hospital/" + uuidInvestigation + "/service/"+serviceInvestigation.id, serviceInvestigation, { headers: { "Authorization": localStorage.getItem("jwt") } }).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
            reject(response.data); 
        })
        .catch((error) => {
            reject(error);
        });
    });
}

export function saveBoxService(uuidInvestigation: string, box:IBox): Promise<{ status: number, box: IBox }> {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/box", box, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updateBoxService(uuidInvestigation: string, box:IBox, typeAgenda:AgendasTypes): Promise<{ status: number, box: IBox }> {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/box/"+box.uuid, box, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function saveAgendaService(uuidInvestigation: string, agenda:IAgenda, typeAgenda:AgendasTypes): Promise<{ status: number, agenda: IAgenda }> {
    return new Promise((resolve, reject) => {
        axios
            .post(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/" + typeAgenda, agenda, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updateAgendaService(uuidInvestigation: string, agenda:IAgenda, typeAgenda:AgendasTypes): Promise<{ status: number, agenda: IAgenda }> {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation+"/"+typeAgenda+"/"+agenda.uuid, agenda, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function deleteAgendaService(uuidInvestigation: string, uuidAgenda:string): Promise<{ status: number, agenda: IAgenda }> {
    return new Promise((resolve, reject) => {
        axios
            .delete(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation +"/"+uuidAgenda, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function deleteBoxService(uuidInvestigation: string, uuidBox:string): Promise<{ status: number, box: IBox }> {
    return new Promise((resolve, reject) => {
        axios
            .delete(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation +"/box/"+uuidBox, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
export function getAgendaService(uuidInvestigation: string, uuidAgenda:string): Promise<{ status: number, agenda: IAgenda }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation+"/"+uuidAgenda, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function blockDateAgenda(uuidInvestigation: string, uuidAgenda:string, dateTS:number): Promise<{ status: number, agenda: IAgenda }> {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation+"/agenda/"+uuidAgenda+"/blockdate/"+dateTS, {}, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function freeDateAgenda(uuidInvestigation: string, uuidAgenda:string, dateTS:number): Promise<{ status: number, agenda: IAgenda }> {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation+"/agenda/"+uuidAgenda+"/freedate/"+dateTS, {}, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

// What the appointments-by-day endpoint can actually send: `patient` is null when the
// appointment outlived its patient's deletion (SHER-924). Only the filter below turns it
// into an IAppointment, whose `patient` every consumer dereferences.
type AppointmentWire = Omit<IAppointment, 'patient'> & { patient: IAppointment['patient'] | null };

function hasPatient(appointment: AppointmentWire): appointment is IAppointment {
    return appointment.patient != null;
}

export function getAppoinmentsDateService(uuidInvestigation: string, uuidAgenda:string, date:Date,): Promise<{ status: number, appointments: IAppointment[] }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/appointment/agenda/"+uuidAgenda+"/date/"+date.getTime(), { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    // SHER-924: the endpoint loads `patient` as a relation, which drops a
                    // soft-deleted patient, so an appointment left live after its patient was
                    // deleted arrives with `patient: null`. Every consumer reads
                    // `appointment.patient.uuid`; one such row unmounted the whole agenda page.
                    // A deleted patient's appointment has nothing to show, so it stops here.
                    resolve({
                        ...response.data,
                        appointments: (response.data.appointments as AppointmentWire[]).filter(hasPatient),
                    });
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function cancelAppointmentService(uuidInvestigation: string, uuidAppointment:string, byUser:boolean): Promise<{ status: number, appointments: IAppointment[] }> {
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/appointment/"+uuidAppointment+"/cancel", { byUser },{ headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function updateAppoinmentsService(uuidInvestigation: string, uuidAppointment:string, forceBilling:boolean = false): Promise<{ status: number, appointment: IAppointment }> {
    // forceBilling (SHER-395): when a physiotherapy patient has no available forfait
    // session, the API blocks check-in with errorCode "PATIENT_NOT_VOUCHER". Passing
    // forceBilling lets a confirmed check-in bill the consultation instead (the visit
    // goes to PENDING_PAYMENT → red "$"), like a general appointment.
    return new Promise((resolve, reject) => {
        axios
            .put(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/appointment/"+uuidAppointment+"/showup", { forceBilling }, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

/**
 * Update consultation appointment (reschedule/transfer to different agenda or time)
 */
export function updateConsultationAppointmentService(
    uuidInvestigation: string, 
    uuidAppointment: string, 
    updateData: {
        uuidAgenda?: string | null;
        timestamp?: number | null;
        userTimeZone?: string | null;
    }
): Promise<{ status: number, appointment: IAppointment }> {
    return new Promise((resolve, reject) => {
        axios
            .patch(
                import.meta.env.VITE_APP_API_URL + 
                "/agenda/" + uuidInvestigation + 
                "/appointment/consultation/" + uuidAppointment,
                updateData,
                { headers: { "Authorization": localStorage.getItem("jwt") } }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

/**
 * Update surgery appointment (reschedule/transfer to different agenda or time)
 */
export function updateSurgeryAppointmentService(
    uuidInvestigation: string, 
    uuidAppointment: string, 
    updateData: {
        uuidAgenda?: string | null;
        timestamp?: number | null;
        userTimeZone?: string | null;
    }
): Promise<{ status: number, appointment: IAppointment }> {
    return new Promise((resolve, reject) => {
        axios
            .patch(
                import.meta.env.VITE_APP_API_URL + 
                "/agenda/" + uuidInvestigation + 
                "/appointment/surgery/" + uuidAppointment,
                updateData,
                { headers: { "Authorization": localStorage.getItem("jwt") } }
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

/**
 * Generic update appointment service - routes to correct endpoint based on agenda type
 */
export function updateAppointmentService(
    uuidInvestigation: string, 
    uuidAppointment: string, 
    typeAgenda: AgendasTypes,
    updateData: {
        uuidAgenda?: string | null;
        timestamp?: number | null;
        userTimeZone?: string | null;
    }
): Promise<{ status: number, appointment: IAppointment }> {
    if (typeAgenda === AgendasTypes.CONSULTATION) {
        return updateConsultationAppointmentService(uuidInvestigation, uuidAppointment, updateData);
    } else if (typeAgenda === AgendasTypes.SURGERY) {
        return updateSurgeryAppointmentService(uuidInvestigation, uuidAppointment, updateData);
    } else {
        return Promise.reject(new Error('Invalid agenda type'));
    }
}

/**
 * Helper function to prepare appointment update data from drag-and-drop event
 */
export function prepareAppointmentUpdateData(
    appointment: IAppointment,
    newAgendaUuid?: string,
    newStartDateTime?: Date
): {
    uuidAgenda?: string | null;
    timestamp?: number | null;
    userTimeZone: string;
} {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    const updateData: {
        uuidAgenda?: string | null;
        timestamp?: number | null;
        userTimeZone: string;
    } = {
        userTimeZone
    };
    
    if (newAgendaUuid !== undefined) {
        updateData.uuidAgenda = newAgendaUuid;
    }
    
    if (newStartDateTime !== undefined) {
        updateData.timestamp = newStartDateTime.getTime();
    }
    
    return updateData;
}

/**
 * Parse appointment update error and return user-friendly translation key
 */
export function parseAppointmentUpdateError(error: any): string {
    if (!error.response) {
        return 'pages.hospital.outpatients.appointment.transfer.error';
    }
    
    const status = error.response.status;
    const errorCode = error.response.data?.errorCode;
    
    // Completed appointment
    if (errorCode === 'COMPLETED_APPOINTMENT') {
        return 'pages.hospital.outpatients.appointment.error.completed_appointment';
    }
    
    // Cancelled appointment
    if (errorCode === 1) {
        return 'pages.hospital.outpatients.appointment.error.cancelled_appointment';
    }
    
    // Time slot conflict
    if (status === 400 || status === 409) {
        return 'pages.hospital.outpatients.appointment.error.slot_not_available';
    }
    
    // Permission error
    if (status === 403) {
        return 'pages.hospital.outpatients.appointment.error.cannot_transfer';
    }
    
    // Not found
    if (status === 404) {
        return 'pages.hospital.outpatients.appointment.error.not_found';
    }
    
    // Type mismatch
    if (error.response.data?.errorMessage?.includes('type mismatch')) {
        return 'pages.hospital.outpatients.appointment.error.type_mismatch';
    }
    
    return 'pages.hospital.outpatients.appointment.transfer.error';
}

export function getPatientsAppoinmentsService(uuidInvestigation: string, uuidPatient:string, typeAgenda:AgendasTypes): Promise<{ status: number, appointments: IAppointment[] }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/patient/"+uuidPatient+"/appointments/"+typeAgenda, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export const checkRequestAppointment = async (uuidInvestigation: string, requestId: number): Promise<{ status: number, appointment: IAppointment }> => {
    const response = await axios.get(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/appointment/request/"+requestId, { headers: { "Authorization": localStorage.getItem("jwt") } })
    if (response.status === 200) {
        return response.data;
    }
    throw new Error('Failed to fetch appointment');
};

export function getAppointmentService(uuidAppointment: string, uuidInvestigation: string): Promise<{ status: number, appointment: IAppointment }> {
    return new Promise((resolve, reject) => {
        axios
            .get(import.meta.env.VITE_APP_API_URL + "/agenda/" + uuidInvestigation + "/appointment/" + uuidAppointment, { headers: { "Authorization": localStorage.getItem("jwt") } })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}